var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.9981 18.928c.678-.391 1.459-.424 2.135-.164.564.217 1.209.037 1.5919-.43.6831-.833 1.2341-1.778 1.6211-2.805.221-.587.012-1.232-.467-1.638-.539-.454-.881-1.13-.881-1.891s.3419-1.437.8799-1.893c.479-.406.6891-1.05.4671-1.638-.387-1.026-.937-1.972-1.621-2.805-.383-.467-1.028-.647-1.592-.43-.675.262-1.456.229-2.134-.162-.68-.393-1.1-1.056-1.21-1.775-.09-.588-.556-1.058-1.143-1.158-.536-.091-1.086-.139-1.647-.139s-1.111.048-1.647.139c-.58705.1-1.05205.57-1.14305 1.158-.11.719-.53 1.382-1.21 1.775-.678.391-1.459.424-2.135.163-.564-.217-1.209-.037-1.592.43-.683.833-1.233 1.778-1.62 2.805-.222.587-.012 1.232.467 1.637.538.456.88 1.132.88 1.893s-.342 1.437-.88 1.893c-.479.406-.689 1.05-.467 1.638.387 1.026.937 1.972 1.621 2.805.383.467 1.028.647 1.592.43.675-.262 1.456-.229 2.134.162.68.393 1.1 1.056 1.21 1.775.09.588.556 1.058 1.14305 1.158.536.091 1.086.139 1.647.139s1.111-.048 1.647-.139c.587-.099 1.053-.569 1.143-1.158.11-.719.53-1.382 1.21-1.775z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 8c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2ebb95ed2ae8a6aa0a74f3f9357d6066.svg";
export { ForwardRef as ReactComponent };